import {
  Box,
  Flex,
  Image,
  Modal,
  ModalContent,
  ModalOverlay,
  RadioGroup,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useState } from "react";
import CustomHeading from "../../components/text/CustomHeading";
import CustomText from "../../components/text/CustomText";
import CustomInput from "../../components/form/CustomInput";
import { IconChevronDown, IconEyeOff, IconX } from "@tabler/icons-react";
import CustomButton from "../../components/buttons/CustomButton";
import AuthHeroImg from "../../assets/images/auth-hero.svg";
import Logo from "../../assets/images/Logo.svg";
import { useNavigate } from "react-router-dom";
import KYCVector from "../../svgs/KYCVector";

function UpdatePassword() {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [step, setStep] = useState(1);
  return (
    <Flex
      align="center"
      justify="space-between"
      minH="100vh"
      py="50px"
      px="150px"
      gap="50px"
    >
      <Flex
        flexDir="column"
        gap="40px"
        borderRadius="24px"
        border="1px solid"
        borderColor="yess.border"
        bg="yess.g1"
        p="56px 40px"
        maxW="480px"
        w="100%"
      >
        <Flex flexDir="column">
          <CustomHeading text="Update Password" />
          <CustomText
            text="Change your temporary password and update with a secure one."
            color="yess.neutral600"
          />
        </Flex>
        <Flex gap="22px" flexDir="column">
          <Flex flexDir="column">
            <CustomText text="Current Temporary Password" size="12px" />
            <CustomInput
              type="password"
              ph="Temporary Password"
              rightIco={<IconEyeOff size="14px" color="#354052" />}
            />
          </Flex>
          <Flex flexDir="column">
            <CustomText text="New Password" size="12px" />
            <CustomInput
              type="password"
              ph="New Password"
              rightIco={<IconEyeOff size="14px" color="#354052" />}
            />
          </Flex>
          <Flex flexDir="column">
            <CustomText text="Repeat Password" size="12px" />
            <CustomInput
              type="password"
              ph="Confirm password"
              rightIco={<IconEyeOff size="14px" color="#354052" />}
            />
          </Flex>
          <Box mt="10px">
            <CustomButton
              btnTitle="Update Password"
              bg="yess.secondary_gold"
              onClick={() => {
                onOpen();
              }}
            />
          </Box>
        </Flex>
      </Flex>
      <Flex flexDir="column">
        <Image src={AuthHeroImg} alt="Auth Hero Image" maxH="80vh" />
        <Image src={Logo} alt="Logo" w="184px" h="87px" ms="auto" mt="-50px" />
      </Flex>
      <Modal isOpen={isOpen} onClose={() => {}} isCentered>
        <ModalOverlay />
        <ModalContent maxW="600px" borderRadius="16px">
          <Flex
            p="24px"
            borderBottom="1px solid #0B0A0A"
            justify="space-between"
            align="center"
          >
            <CustomText
              text="KYC Verification"
              size="20px"
              color="yess.base_black"
            />
            <IconX
              size="20px"
              color="#0B0A0A"
              cursor="pointer"
              onClick={onClose}
            />
          </Flex>
          {/* Step 01 */}
          <Flex
            p="24px"
            align="center"
            flexDir="column"
            gap="24px"
            display={step === 1 ? "flex" : "none"}
          >
            <KYCVector />
            <CustomText
              text="Please complete your verification."
              color="yess.neutral600"
              align="center"
            />
            <CustomButton
              btnTitle="Continue Verification"
              bg="yess.secondary_gold"
              onClick={() => {
                setStep(2);
              }}
            />
          </Flex>
          {/* Step 02 */}
          <Flex
            p="24px"
            flexDir="column"
            gap="24px"
            maxW="500px"
            w="100%"
            mx="auto"
            display={step === 2 ? "flex" : "none"}
          >
            <CustomText
              text="IDENTITY DOCUMENT"
              size="20px"
              weight="700"
              color="yess.base_black"
              align="center"
            />
            <Flex flexDir="column" gap="6px">
              <CustomText text="Select Issuing Country" size="12px" />
              <CustomInput
                type="text"
                ph="Saudi Arabia"
                rightIco={<IconChevronDown size="14px" color="#354052" />}
              />
            </Flex>
            <Flex flexDir="column" gap="6px">
              <CustomText text="Choose Your Document Type" size="12px" />
              <RadioGroup>
                <Flex align="center" gap="8px">
                  <input type="radio" />
                  <CustomText text="Passport" size="12px" />
                </Flex>
                <Flex align="center" gap="8px">
                  <input type="radio" />
                  <CustomText text="National ID" size="12px" />
                </Flex>
                <Flex align="center" gap="8px">
                  <input type="radio" />
                  <CustomText text="Driver's License" size="12px" />
                </Flex>
                <Flex align="center" gap="8px">
                  <input type="radio" />
                  <CustomText text="Iqama" size="12px" />
                </Flex>
              </RadioGroup>
            </Flex>
            <Flex justify="center">
              <CustomButton
                btnTitle="Continue"
                bg="yess.secondary_gold"
                onClick={() => {
                  navigate("/kyc-pending");
                }}
              />
            </Flex>
          </Flex>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default UpdatePassword;
